











import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductSpecification } from '@/models/catalog/ProductSpecification';

@Component
export default class ProductSpecificationTable extends Vue {
    @Prop()
    private specifications!: ProductSpecification[];
}
